<template>
  <a
    :data-bs-toggle="collapse ? 'collapse' : ''"
    :href="collapse ? `#${collapseRef}` : collapseRef"
    :aria-controls="collapseRef"
    aria-expanded="false"
    class="nav-link px-0 ms-1 me-0"
    v-bind="$attrs"
    type="button"
    @click="isExpanded = !isExpanded"
  >
    <div
      class="text-center bg-white shadow icon icon-shape icon-sm border-radius-md d-flex align-items-center justify-content-center me-2"
    >
      <slot name="icon"></slot>
    </div>
    <span class="nav-link-text" :class="isRTL ? ' me-1' : 'ms-1'">{{
      navText
    }}</span>
  </a>
  <span>
    <!-- 右：チェックボックス -->
    <input
      v-if="isDeleteMode"
      type="checkbox"
      class="form-check-input bulk-select me-1"
      :checked="selectedConversations.includes(conversationId)"
      @click.stop
      @change="$emit('conversation-toggle', conversationId)"
    />
  </span>
  <div :id="collapseRef" class="collapse">
    <slot name="list"></slot>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { cilTrash } from '@coreui/icons'
export default {
  name: 'SidenavCollapse',
  data() {
    return {
      cilTrash,
    }
  },
  props: {
    collapseRef: {
      type: String,
      required: true,
    },
    conversationId: {
      type: String,
      required: true,
    },
    navText: {
      type: String,
      required: true,
    },
    collapse: {
      type: Boolean,
      default: true,
    },
    isDeleteMode: Boolean,
    selectedConversations: Array,
  },
  computed: {
    ...mapState(['isRTL']),
  },
}
</script>
